// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* COLORS */
/* MEASUREMENTS */
.v-select[data-v-620c4194] {
  background: #fff;
  font-size: 0.875rem;
}
.tile[data-v-620c4194] {
  padding-top: 0;
  padding-bottom: 0;
}
.badge[data-v-620c4194] {
  font-size: 1em;
  font-weight: 500;
  margin: 10px 0;
}
.vue-data-table[data-v-620c4194] td {
  vertical-align: middle;
  padding: 0;
}
.pagination-container[data-v-620c4194],
.result-count[data-v-620c4194] {
  position: relative;
  z-index: 1;
}
.datepicker .input-group[data-v-620c4194] {
  padding: 0;
}
.datepicker[data-v-620c4194] .form-control.input {
  padding: 0.5em;
  font-size: 0.875rem;
}
[class^="icon-"][data-v-620c4194]:before,
[class*=" icon-"][data-v-620c4194]:before {
  color: inherit;
}
[data-v-620c4194] .v-select:not(.vs--open) .vs__selected + .vs__search {
  height: 0;
  margin: 0;
}
[data-v-620c4194] .vs__dropdown-toggle,[data-v-620c4194] .vs__dropdown-menu {
  border: 1px solid #ced4da;
  border-radius: 0.2rem;
}
[data-v-620c4194] .vs__dropdown-menu {
  width: auto;
  position: fixed;
  /* to overflow the side bar */
  top: auto;
  left: auto;
  right: auto;
  bottom: auto;
  z-index: 1002;
}
.alert-issues[data-v-620c4194] {
  background: #ffc107;
  color: #000;
  font-weight: 600;
}
`, "",{"version":3,"sources":["webpack://./../Search.3.vue","webpack://./admin/pages/Search/Search.3.vue"],"names":[],"mappings":"AAAA,WAAW;AACX,iBAAiB;ACCjB;EACI,gBAAA;EACA,mBAAA;ADCJ;ACCA;EACI,cAAA;EACA,iBAAA;ADCJ;ACCA;EACI,cAAA;EACA,gBAAA;EACA,cAAA;ADCJ;ACEI;EACI,sBAAA;EACA,UAAA;ADAR;ACGA;;EAEI,kBAAA;EACA,UAAA;ADDJ;ACGA;EAEQ,UAAA;ADFR;ACAA;EAKQ,cAAA;EACA,mBAAA;ADFR;ACKA;;EAEI,cAAA;ADHJ;ACKA;EAGQ,SAAA;EACA,SAAA;ADLR;ACCA;EAQQ,yBAAA;EACA,qBAAA;ADLR;ACJA;EAYQ,WAAA;EACA,eAAA;EDLN,6BAA6B;ECMvB,SAAA;EACA,UAAA;EACA,WAAA;EACA,YAAA;EACA,aAAA;ADJR;ACQA;EACI,mBAAA;EACA,WAAA;EACA,gBAAA;ADNJ","sourcesContent":["/* COLORS */\n/* MEASUREMENTS */\n.v-select {\n  background: #fff;\n  font-size: 0.875rem;\n}\n.tile {\n  padding-top: 0;\n  padding-bottom: 0;\n}\n.badge {\n  font-size: 1em;\n  font-weight: 500;\n  margin: 10px 0;\n}\n.vue-data-table ::v-deep(td) {\n  vertical-align: middle;\n  padding: 0;\n}\n.pagination-container,\n.result-count {\n  position: relative;\n  z-index: 1;\n}\n.datepicker .input-group {\n  padding: 0;\n}\n.datepicker ::v-deep(.form-control.input) {\n  padding: 0.5em;\n  font-size: 0.875rem;\n}\n[class^=\"icon-\"]:before,\n[class*=\" icon-\"]:before {\n  color: inherit;\n}\n::v-deep .v-select:not(.vs--open) .vs__selected + .vs__search {\n  height: 0;\n  margin: 0;\n}\n::v-deep .vs__dropdown-toggle,\n::v-deep .vs__dropdown-menu {\n  border: 1px solid #ced4da;\n  border-radius: 0.2rem;\n}\n::v-deep .vs__dropdown-menu {\n  width: auto;\n  position: fixed;\n  /* to overflow the side bar */\n  top: auto;\n  left: auto;\n  right: auto;\n  bottom: auto;\n  z-index: 1002;\n}\n.alert-issues {\n  background: #ffc107;\n  color: #000;\n  font-weight: 600;\n}\n","\n@import \"/lib/Colors.less\";\n.v-select {\n    background: #fff;\n    font-size: 0.875rem;\n}\n.tile {\n    padding-top: 0;\n    padding-bottom: 0;\n}\n.badge {\n    font-size: 1em;\n    font-weight: 500;\n    margin: 10px 0;\n}\n.vue-data-table {\n    & ::v-deep(td) {\n        vertical-align: middle;\n        padding: 0;\n    }\n}\n.pagination-container,\n.result-count {\n    position: relative;\n    z-index: 1;\n}\n.datepicker {\n    .input-group {\n        padding: 0;\n    }\n    ::v-deep(.form-control.input) {\n        padding: 0.5em;\n        font-size: 0.875rem;\n    }\n}\n[class^=\"icon-\"]:before,\n[class*=\" icon-\"]:before {\n    color: inherit;\n}\n::v-deep {\n    // avoid white space issue with v-select\n    .v-select:not(.vs--open) .vs__selected + .vs__search {\n        height: 0;\n        margin: 0;\n    }\n    .vs__dropdown-toggle,\n    .vs__dropdown-menu {\n        border: 1px solid #ced4da;\n        border-radius: 0.2rem;\n    }\n    .vs__dropdown-menu {\n        width: auto;\n        position: fixed; /* to overflow the side bar */\n        top: auto;\n        left: auto;\n        right: auto;\n        bottom: auto;\n        z-index: 1002; // To avoid being overlapped by modal\n    }\n}\n\n.alert-issues {\n    background: @warning;\n    color: #000;\n    font-weight: 600;\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
